
const HasLocalizationExtensions = {
  "name": "HasLocalizationExtensions",
  "kind": "INTERFACE",
  "fieldBaseTypes": {
    "localizationExtensions": "LocalizationExtensionConnection"
  },
  "possibleTypes": ["DraftOrder", "Order"]
};
export default HasLocalizationExtensions;